import React, { FC } from "react";

const Lights: FC = () => {

  return (
    <>
      <ambientLight color="#ffffff" intensity={5} />
    </>
  )
}

export default Lights;
